var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainmenuKeyTerms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.657,
    height: 20.501,
    viewBox: "0 0 16.657 20.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7479",
    "data-name": "Rectangle 7479",
    width: 16.657,
    height: 20.501,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22425",
    "data-name": "Group 22425",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13222",
    "data-name": "Path 13222",
    d: "M0,10.206q0-4.13,0-8.26A1.71,1.71,0,0,1,1.945,0Q8.328,0,14.712,0a1.709,1.709,0,0,1,1.944,1.945q0,8.3,0,16.61A1.71,1.71,0,0,1,14.712,20.5q-6.383,0-12.767,0A1.71,1.71,0,0,1,0,18.555q0-4.175,0-8.349m15.225.067c0-2.768-.007-5.537.007-8.305,0-.4-.115-.545-.532-.543q-6.362.019-12.723,0c-.434,0-.556.141-.555.566q.018,8.261,0,16.521c0,.424.12.568.554.566,4.226-.013,8.452-.007,12.679-.008.56,0,.569-.01.569-.58q0-4.108,0-8.216",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13223",
    "data-name": "Path 13223",
    d: "M72.818,172.236c-.891,0-1.782,0-2.673,0-.524,0-.844-.275-.849-.706s.312-.72.832-.721q2.74-.006,5.48,0c.514,0,.836.294.827.727s-.328.7-.855.7c-.921,0-1.841,0-2.762,0",
    transform: "translate(-63.108 -155.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13224",
    "data-name": "Path 13224",
    d: "M72.884,85.526c.891,0,1.781,0,2.672,0,.557,0,.883.276.875.719-.008.426-.33.706-.855.708q-2.717.009-5.433,0c-.523,0-.846-.285-.853-.71-.007-.444.317-.714.877-.717.905,0,1.811,0,2.716,0",
    transform: "translate(-63.104 -77.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13225",
    "data-name": "Path 13225",
    d: "M72.8,129.46c-.891,0-1.781,0-2.672,0-.525,0-.843-.279-.842-.708s.322-.717.843-.719q2.739-.01,5.478,0a.737.737,0,0,1,.821.741c-.013.413-.322.68-.821.684-.935.007-1.87,0-2.806,0",
    transform: "translate(-63.103 -116.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13226",
    "data-name": "Path 13226",
    d: "M71.424,44.17c-.445,0-.89.007-1.335,0a.717.717,0,1,1,0-1.426q1.357-.011,2.714,0a.715.715,0,1,1,0,1.425c-.46.01-.92,0-1.379,0",
    transform: "translate(-63.109 -38.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13227",
    "data-name": "Path 13227",
    d: "M36.48,41.04a.955.955,0,1,1-.922-.966.976.976,0,0,1,.922.966",
    transform: "translate(-31.483 -36.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13228",
    "data-name": "Path 13228",
    d: "M36.476,169.1a.956.956,0,1,1-.911-.977.975.975,0,0,1,.911.977",
    transform: "translate(-31.479 -153.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13229",
    "data-name": "Path 13229",
    d: "M35.525,84.7a.95.95,0,0,1-.955-.922.955.955,0,1,1,1.91,0,.951.951,0,0,1-.956.921",
    transform: "translate(-31.483 -75.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13230",
    "data-name": "Path 13230",
    d: "M36.48,126.553a.956.956,0,0,1-1.911-.035.956.956,0,0,1,1.911.035",
    transform: "translate(-31.483 -114.379)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainmenuKeyTerms);
export default __webpack_public_path__ + "static/media/Mainmenu-key-terms.07de6eb3f7b47c5bb372531eb4b5f958.svg";
export { ForwardRef as ReactComponent };